import lrDialog from './_src/lrDialog.vue'

lrDialog.install = function(Vue) {
  Vue.component(lrDialog.name, lrDialog)
}

export default lrDialog